module.exports = __webpack_public_path__ + "static/media/f16s.8c52efe1.png";